module.exports = __webpack_public_path__ + "f631823cb32130471a1f187059523add.png";